const ACTIONS = {
  SET_INITIAL_DATA: "set-data",
  
  ADD_FIELD: "add-field",
  REMOVE_FIELD: "remove-field",
  
  DATE_CHANGE: "date-change",
  DATE_SET_ERRORS: "date-set-errors",
  DATE_REMOVE_ERRORS: "date-remove-errors",
};

const initialField = (onChange = null) => ({
  value: "",
  validation: {
    required: true,
    isInvalid: false,
    errors: [],
  },
  onChange,
  disabled: false,
});

const formInfoReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading,
      };
    }
    
    case ACTIONS.ADD_FIELD: {
      const { name } = action;
      return {
        ...state,
        data: {
          ...state.data,
          [name]: state.data?.[name] ?? initialField(),
        },
      };
    }
    
    case ACTIONS.REMOVE_FIELD: {
      const { name } = action;
      if (!state.data?.[name]) return state;
      const next = { ...state.data };
      delete next[name];
      return { ...state, data: next };
    }
    
    case ACTIONS.DATE_CHANGE: {
      const path = state.data[action.name] ?? initialField();
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
        },
      };
    }
    
    case ACTIONS.DATE_SET_ERRORS: {
      const path = state.data[action.name] ?? initialField();
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors ?? [],
            },
          },
        },
      };
    }
    
    case ACTIONS.DATE_REMOVE_ERRORS: {
      const path = state.data[action.name] ?? initialField();
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
        },
      };
    }
    
    default:
      return state;
  }
};

export { ACTIONS, formInfoReducer };
